const ListNotifikasi = () =>
  /* webpackChunkName: "view-[request]" */ import(
    "@/views/Notifikasi/list.vue"
  );

export default [
  {
    path: "/notifikasi",
    name: "ListNotifikasi",
    component: ListNotifikasi,
    meta: { requiresAuth: true, title: "Notifikasi", Permission: "Exception" },
  },
];
